module.exports = __webpack_public_path__ + "static/media/google_meet_activities_logo.1bbee6c5.svg";